import Entity from 'txp-data/lib/schema/Entity';
import { trace } from 'owa-trace';

export default function handleOwaDateError(e?: Error, entity?: Entity) {
    e &&
        entity &&
        trace.error(
            `[TXP_tryCreateOwaDate]: ${e.message}, Entity Type: ${entity.entityType}, Template: ${
                entity.source
            }`
        );
}
